import { render, staticRenderFns } from "./ConsultantsApplications.vue?vue&type=template&id=5b1cd8e6&"
import script from "./ConsultantsApplications.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ConsultantsApplications.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports